export default __webpack_public_path__ + "static/media/used-cubicles-teknion-3.efa026cd.jpg";